import {
	ORDER_BY,
	getDateString,
	sortNumberBy,
} from "@website-builder/utilities-index";
import {
	getStoriesByContentType,
	getIndexablePages,
	filterBySlug,
} from "@website-builder/utilities-index";

export const contentType = "RebrandBlog";

export default (
	storyList = [],
	hideNoIndexPosts = false,
	header = "Recent Posts",
) => {
	let list = storyList?.[contentType] || [];
	if (hideNoIndexPosts) {
		list = getIndexablePages(list);
	}
	let blogList = getBlogItemProps(list);
	blogList = sortNumberBy(blogList, "dateInMilliSec", ORDER_BY.ASCENDING);
	return {
		header,
		blogList,
		hideNoIndexPosts,
	};
};

export const getBlogItemProps = (list = []) => {
	return list?.map(
		({
			content: { title, coverImage = {}, dateOfPublishing = "" },
			full_slug,
			published_at = null,
		}) => {
			return {
				title,
				coverImage: {
					image: coverImage?.[0]?.image?.image,
					alt: coverImage?.[0]?.image?.altTag,
					base64: coverImage?.[0]?.image?.base64,
				},
				link: "/" + full_slug,
				dateOfPublishing: dateOfPublishing
					? getDateString(dateOfPublishing)
					: published_at
						? getDateString(published_at)
						: "",
				dateInMilliSec: dateOfPublishing
					? new Date(dateOfPublishing).getTime()
					: published_at
						? new Date(published_at).getTime()
						: 0,
				// dateInMilliSec is used for sorting
				full_slug, // Used for filtering by category. We are using snake case to reuse an old function
			};
		},
	);
};

export const filterBlogsByCategories = (pages) => {
	if (typeof window !== "undefined") {
		let filterSlug = window.location.pathname;
		// remove storyblok space name from path
		if (process.env.GATSBY_TEMPLATE === "PREVIEW") {
			[, , ...filterSlug] = filterSlug.split("/");
			filterSlug = filterSlug.join("/");
		} else {
			filterSlug = filterSlug.replace("/", "");
		}

		if (filterSlug) {
			return filterBySlug(pages, filterSlug);
		}
		return pages;
	}
};
